import React, { useRef } from "react";
import { connect } from "react-redux";
import { MCard, MSpinner } from "components/Shared";
import { CustomerDetailsDto, CustomerListModel } from "interfaces/Mueller.Business.Models.ts";
import { DATA_TYPE_DROPDOWN } from "typeConstants/dataTypes";
import { userHasRight } from "selectors/rights";
import { CUSTOMER_ACCOUNT_EDIT } from "typeConstants/rights";
import { MCardControlMethods } from "components/Shared/MCard.tsx";
import { mapCustomerDetailsToCustomerUpdate } from "components/Customer/Profile/CustomerEmailCaseSettings.tsx";
import { updateCustomer } from "requests/customer";
import { getCustomerDetails } from "actions/customer";

export interface ICustomerDetailsQadDisplayProps {
  cellWidth: number,
  customerDetails: CustomerDetailsDto,
  customerList: CustomerListModel[],
  isFetchingCustomerDetails: boolean,
  canEditCustomerDetails: boolean,
  getCustomerDetails: (customerNumber: number) => void,
}

//This component relies on customer data in redux
const CustomerDetailsQadDisplay = ({
  cellWidth,
  customerDetails,
  customerList,
  isFetchingCustomerDetails,
  canEditCustomerDetails,
  getCustomerDetails,
}: ICustomerDetailsQadDisplayProps) => {

  const mounted = useRef<boolean>(true);
  const cardControlMethods = useRef<MCardControlMethods>();

  const getQADNames = () => {
    const qadNameNumberDtos = customerList.find(c => c.id === customerDetails.id)?.qaDirector;
    if (qadNameNumberDtos && qadNameNumberDtos.length > 0) {
      return qadNameNumberDtos.map(qad => `${qad.firstLastNameOnly}`).join(", ");
    }
    else {
      return "No QA Director Assigned";
    }
  };

  const customerEditFinished = (fieldsChanged) => {
    if (fieldsChanged.length) {
      let postObj = { ...mapCustomerDetailsToCustomerUpdate(customerDetails), ...cardControlMethods.current.getEditedDataObject(true) };
      postObj.customerNumber = customerDetails.number;
      updateCustomer(customerDetails.number, postObj, () => getCustomerDetails(customerDetails.number), mounted);
    }
  };



  if (isFetchingCustomerDetails || !customerList || !customerDetails) return <MSpinner />;

  const auditOptions = [
    { label: "Default", value: 0 },
    { label: "10%", value: 10 },
    { label: "20%", value: 20 },
    { label: "50%", value: 50 },
    { label: "100%", value: 100 }
  ];

  return (
    <MCard
      title="QA Details"
      isEditable={canEditCustomerDetails}
      onEditFinished={customerEditFinished}      
      cellWidth={cellWidth}
      getControlMethods={cm => cardControlMethods.current = cm}
      fields={[
        {
          key: "qaDirector",
          label: "QA Director",
          value: getQADNames(),
          editable: false,
        },
        {
          key: "auditPercentage",
          label: "% of Cases to Audit",
          value: auditOptions.find(s => s.value === customerDetails.auditPercentage),
          editable: canEditCustomerDetails,
          dataType: DATA_TYPE_DROPDOWN,
          dataTypeOptions: {
            options: auditOptions
          }
        }
      ]}
      children={<p>Please use Employee Mappings to change assignments</p>}
    />
  );
};

const mapStateToProps = state => ({
  customerDetails: state.customer.customerDetails,
  customerList: state.customer.customerList,
  isFetchingCustomerDetails: state.customer.fetchingCustomerDetails,
  canEditCustomerDetails: userHasRight(CUSTOMER_ACCOUNT_EDIT)(state),
});

const mapDispatchToProps = dispatch => ({
  getCustomerDetails(customerNumber: number) {
    dispatch(getCustomerDetails(customerNumber));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetailsQadDisplay);